export const getFilledProps = (obj) => {
    const filledPropsArray = Object
        .entries(obj)
        .filter(([prop, value]) => value !== '');

    return Object.fromEntries(filledPropsArray);
};